var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('p',{staticClass:"text-h4 text--primary"},[_vm._v("Works")]),_c('v-divider',{staticClass:"my-5"}),_c('Tips'),_c('p',[_vm._v("その他ECサイト作成、APIを用いた音楽、書籍アプリなど作成経験有 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }